import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { registerMicroApps, start, addGlobalUncaughtErrorHandler } from 'qiankun'
import microApps from './micro-app'
import 'nprogress/nprogress.css'
import { openAuth, backFetchQuery } from 'oauth-teams-ts/lib'
import { get, post } from './utils/http/index.js'

const scriptElements = document.querySelectorAll('script[src]')
scriptElements.forEach(script => {
  if (script.src.includes('jsMicMain')) {
    console.log('JS File Path:', script.src)
    const index = script.src.indexOf('jsMicMainapp')
    if (index !== -1) {
      const result = script.src.substring(index)
      console.log('JS File Path:', result)
      const webPageVersion = localStorage.getItem('webPageVersion')
      if (webPageVersion) {
        if (webPageVersion !== result) {
          // const isConfirmed = confirm('网站有新版本！')
          // if (isConfirmed) {
          //   console.log('您选择了确定！')
          //   window.location.reload(true)
          //   localStorage.setItem('webPageVersion', result)
          // } else {
          //   console.log('您选择了取消！')
          // }
          localStorage.setItem('webPageVersion', result)
          window.location.reload(true)
        }
      } else {
        localStorage.setItem('webPageVersion', result)
      }
    } else {
      console.warn('Substring not found')
    }
  }
})

const noLogin = [
  '/teams-backend/general/applicationApply',
  '/teams-backend/general/visitor/outer/code',
  '/teams-backend/general/visitor/list',
  '/teams-backend/general/visitor/apply',
  '/teams-backend/general/visitor/applyDetail',
  '/teams-backend/general/visitor/login',
  '/goal-admin/singlePage/vote/result'
]

export const { version } = require('../package.json')
export const sdkConfig = {
  serverUrl: process.env.VUE_APP_PASSPORT,
  clientId: process.env.VUE_APP_CLIENTID,
  appName: process.env.VUE_APP_APPNAME,
  organizationName: process.env.VUE_APP_ORGANIZATIONNAME,
  redirectPath: window.location.href
}

const onGetLoginParams = ({ code, state, appname }) => {
  const wxworkParams = {
    code,
    Appid: Number(process.env.VUE_APP_APPID),
    Platform: process.env.VUE_APP_PLATFORM,
    Appname: sdkConfig.appName,
    State: state,
    Appversion: version,
    WxAppname: appname
  }
  const uniteParams = {
    code,
    Appid: Number(process.env.VUE_APP_APPID),
    Platform: process.env.VUE_APP_PLATFORM,
    Appname: sdkConfig.appName,
    ClientId: sdkConfig.clientId,
    OrganizationName: sdkConfig.organizationName,
    State: state,
    Appversion: version
  }
  return { wxworkParams, uniteParams }
}

const wxworkLogin = (params) => {
  return get('/api/weCom/login', params)
}

function uniteLogin (params) {
  return post('/api/admin/user/auth/login/v3', params)
}

const { wxworkParams, uniteParams } = onGetLoginParams(backFetchQuery(window.location.href))

Vue.config.productionTip = false

const render = () => {
  const instance = new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')

  // 定义loader方法，loading改变时，将变量赋值给App.vue的data中的isLoading
  function loader (loading) {
    if (instance && instance.$children) {
      // instance.$children[0] 是App.vue，此时直接改动App.vue的isLoading
      instance.$children[0].isLoading = loading
    }
  }

  // 添加全局异常捕获
  addGlobalUncaughtErrorHandler((handler) => {
    console.log('异常捕获', handler)
  })

  // 给子应用配置加上loader方法
  const apps = microApps.map(item => {
    return {
      ...item,
      loader
    }
  })

  registerMicroApps(apps, {
    beforeLoad: (app, global) => {
      console.log('LifeCyclebefore load app.name====>>>>>', app.name, app, global)
    },
    beforeMount: [
      (app) => {
        console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name)
      }
    ],
    afterMount: [
      app => {
        console.log('[LifeCycle] after mount %c%s', 'color: green;', app.name)
      }
    ],
    afterUnmount: [
      app => {
        console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name)
      }
    ]
  })
  // setDefaultMountApp(process.env.VUE_APP_HOME)
  start({
    prefetch: false,
    sandbox: {
      speedy: true
    }
  })
  // loadSingleApp
  // function loadSubAppByRoute (route) {
  //   const matchedApps = apps.filter(app => new RegExp(app.activeRule).test(route))
  //   console.log(matchedApps, 'matchedAppsmatchedApps')
  //   matchedApps.forEach(app => {
  //     // 可以在此处添加额外的逻辑，比如优先级判断
  //     loadMicroApp(app)
  //     prefetchApps(app)
  //   })
  // }
  // // 初始化加载
  // loadSubAppByRoute(window.location.pathname)
}
const isLogin = noLogin.some((item) => window.location.href.indexOf(item) !== -1)

if (isLogin) {
  render()
} else {
  openAuth(
    sdkConfig,
    () => wxworkLogin(wxworkParams),
    () => uniteLogin(uniteParams),
    (e, text) => {
      console.log(e, text, '返回的登录状态', window.location)
      // window.history.replaceState('', '', 'http://localhost:8001/teams-knowledge')
      // resolve(e)
      render()
    }
  )
}
